<template>
<section class="fancy">
	<div class="container">
		<div class="fancy-box">
			<div class="headline-lg">What's included</div>
			<p>Compare what is included in both preorder options.</p>
			<div class="fancy-table-wrapper">
				<div class="fancy-table">
					<div class="fancy-table-row fancy-table-head">
						<div class="fancy-table-col">Feature</div>
						<div class="fancy-table-col">Standalone Application</div>
						<div class="fancy-table-col">Standalone App + Subscription</div>
					</div>
					<div class="fancy-table-row subline">Software</div>
					<div class="fancy-table-row">
						<div class="fancy-table-col">Early Access to the Alpha</div>
						<div class="fancy-table-col"><span class="icon icon-check"></span></div>
						<div class="fancy-table-col"><span class="icon icon-check"></span></div>
					</div>
					<div class="fancy-table-row">
						<div class="fancy-table-col">Access  to the standalone application</div>
						<div class="fancy-table-col"><span class="icon icon-check"></span></div>
						<div class="fancy-table-col"><span class="icon icon-check"></span></div>
					</div>
					<div class="fancy-table-row">
						<div class="fancy-table-col">One year of updates and support</div>
						<div class="fancy-table-col"><span class="icon icon-check"></span></div>
						<div class="fancy-table-col"><span class="icon icon-check"></span></div>
					</div>
					<div class="fancy-table-row subline">Settings</div>
					<div class="fancy-table-row" id="setting_base_fantasy">
						<div class="fancy-table-col">Base Fantasy</div>
						<div class="fancy-table-col"><span class="icon icon-check"></span></div>
						<div class="fancy-table-col"><span class="icon icon-check"></span></div>
						<b-popover target="setting_base_fantasy" triggers="hover" placement="top">
							<template v-slot:title>Base Fantasy</template>
							<img src="@/assets/img/img_setting_basefantasy.png" alt="Image Setting Base Fantasy">
						</b-popover>
					</div>
					<div class="fancy-table-row" id="setting_deadhaus_sonata">
						<div class="fancy-table-col">Deadhaus Sonata</div>
						<div class="fancy-table-col"><span class="icon icon-check"></span></div>
						<div class="fancy-table-col"><span class="icon icon-check"></span></div>
						<b-popover target="setting_deadhaus_sonata" triggers="hover" placement="bottom">
							<template v-slot:title>Deadhaus Sonata</template>
							<img src="@/assets/img/img_setting_deadhaussonata.png" alt="Image Setting Deadhaus Sonata">
						</b-popover>
					</div>
					<div class="fancy-table-row" id="setting_underdark">
						<div class="fancy-table-col">Underdark</div>
						<div class="fancy-table-col"></div>
						<div class="fancy-table-col"><span class="icon icon-check star"></span></div>
						<b-popover target="setting_underdark" triggers="hover" placement="bottom">
							<template v-slot:title>Underdark</template>
							<img src="@/assets/img/img_setting_underdark.png" alt="Image Setting Underdark">
						</b-popover>
					</div>
					<div class="fancy-table-row" id="setting_high_fantasy">
						<div class="fancy-table-col">High Fantasy</div>
						<div class="fancy-table-col"></div>
						<div class="fancy-table-col"><span class="icon icon-check star"></span></div>
						<b-popover target="setting_high_fantasy" triggers="hover" placement="bottom">
							<template v-slot:title>High Fantasy</template>
							<img src="@/assets/img/img_setting_highfantasy.png" alt="Image Setting High Fantasy">
						</b-popover>
					</div>
					<div class="fancy-table-row" id="setting_lost_civilizations">
						<div class="fancy-table-col">Lost Civilizations</div>
						<div class="fancy-table-col"></div>
						<div class="fancy-table-col"><span class="icon icon-check star"></span></div>
						<b-popover target="setting_lost_civilizations" triggers="hover" placement="bottom">
							<template v-slot:title>Lost Civilizations</template>
							<img src="@/assets/img/img_setting_lostciv.png" alt="Image Setting Lost Civilizations">
						</b-popover>
					</div>
					<div class="fancy-table-row" id="setting_wonderous_empires">
						<div class="fancy-table-col">Wonderous Empires</div>
						<div class="fancy-table-col"></div>
						<div class="fancy-table-col"><span class="icon icon-check star"></span></div>
						<b-popover target="setting_wonderous_empires" triggers="hover" placement="bottom">
							<template v-slot:title>Wonderous Empires</template>
							<img src="@/assets/img/img_setting_wondorousempires.png" alt="Image Setting Wonderous Empires">
						</b-popover>
					</div>
					<div class="fancy-table-row" id="setting_age_of_exploration">
						<div class="fancy-table-col">Age of Exploration</div>
						<div class="fancy-table-col"></div>
						<div class="fancy-table-col"><span class="icon icon-check star"></span></div>
						<b-popover target="setting_age_of_exploration" triggers="hover" placement="bottom">
							<template v-slot:title>Age of Exploration</template>
							<img src="@/assets/img/img_setting_age_of_exploration.png" alt="Image Setting Age of Exploration">
						</b-popover>
					</div>
					<div class="fancy-table-row" id="setting_solar_systems_and_galaxies">
						<div class="fancy-table-col">Solar Systems &amp; Galaxies</div>
						<div class="fancy-table-col"></div>
						<div class="fancy-table-col"><span class="icon icon-check star"></span></div>
						<b-popover target="setting_solar_systems_and_galaxies" triggers="hover" placement="bottom">
							<template v-slot:title>Solar Systems &amp; Galaxies</template>
							<img src="@/assets/img/img_setting_solar_systems_and_galaxies.png" alt="Image Setting Solar Systems &amp; Galaxies">
						</b-popover>
					</div>
					<div class="fancy-table-row" id="setting_cyberpunk">
						<div class="fancy-table-col">Cyberpunk</div>
						<div class="fancy-table-col"></div>
						<div class="fancy-table-col"><span class="icon icon-check star"></span></div>
						<b-popover target="setting_cyberpunk" triggers="hover" placement="bottom">
							<template v-slot:title>Cyberpunk</template>
							<img src="@/assets/img/img_setting_cyberpunk.png" alt="Image Setting Cyberpunk">
						</b-popover>
					</div>
					<div class="fancy-table-row" id="setting_space_travel">
						<div class="fancy-table-col">Space Travel</div>
						<div class="fancy-table-col"></div>
						<div class="fancy-table-col"><span class="icon icon-check star"></span></div>
						<b-popover target="setting_space_travel" triggers="hover" placement="bottom">
							<template v-slot:title>Space Travel</template>
							<img src="@/assets/img/img_setting_spacetravel.png" alt="Image Setting Space Travel">
						</b-popover>
					</div>
				</div>
			</div>
			<div class="small text-right mt mb2">* As part of the content subscription</div>
		</div>
	</div>
</section>
</template>

<script>
export default {
	name: 'SectionFancyPreorder'
}
</script>
